import moment from "moment";

const transformValueFormatedtoFloat = (value) =>{
    if(value === undefined)
        return 0;        
    if(value === null)
        return 0;  

    let newValue = value.toString(); 
        
    newValue = newValue.split(".").join("");
    newValue = newValue.replace(",",".");
    newValue = parseFloat(newValue); 
   
    return newValue;
}

const transformValueFloattoFormated = (value) =>{
    
    let valor = value;
    if(!valor)
        valor = 0;
        
    valor = valor.toLocaleString('pt-BR');
    let index = valor.indexOf(",");      
    if(index === -1)
    {
        valor = valor + ',00';
        return valor;
    }

    let resultadoDpsDaVirgula = valor.substring(index+1,valor.length);    
    if(resultadoDpsDaVirgula.length === 1)
        valor = valor + '0';
    
    return valor;
}

function formateMesAno(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('MM/YYYY');
    return dateFormated;
}

function formateDate(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('DD/MM/YYYY');
    return dateFormated;
}

function formateDateSemBarra(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('DD-MM-YYYY');
    return dateFormated;
}


function formateDateApi(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('YYYY-MM-DD');
    return dateFormated;
}

function formateDateandTimeApi(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('YYYY-MM-DD HH:mm:ss');
    return dateFormated;
}

function formateDateandTime(date)
{       
    let dateFormated = date;
    dateFormated = moment(date).format('DD/MM/YYYY HH:mm');
    return dateFormated;
}

function validateDate(date){
    return moment(date, 'DD/MM/YYYY',true).isValid();
}

function convertDate(date){
    let dateConvert = date;
    dateConvert = moment(date, 'DD/MM/YYYY').toDate();
    return dateConvert; 
}

function formateRSS(segmento, categoria){
    let segmentoConvert = segmento;
    segmentoConvert = categoria.includes("RSS") ? segmento.replace("Grande", ""): segmento;
    return segmentoConvert; 
}

function formateMonthName(month){
    switch(month){
        case 1: return 'Janeiro';
        case 2: return 'Fevereiro';
        case 3: return 'Março';
        case 4: return 'Abril';
        case 5: return 'Maio';
        case 6: return 'Junho';
        case 7: return 'Julho';
        case 8: return 'Agosto';
        case 9: return 'Setembro';
        case 10: return 'Outubro';
        case 11: return 'Novembro';
        case 12: return 'Dezembro';
    }
}

export {    
    transformValueFormatedtoFloat,
    transformValueFloattoFormated,
    formateDate,
    formateDateandTime,
    validateDate,
    convertDate,  
    formateDateApi,
    formateDateandTimeApi,
    formateMesAno,
    formateMonthName,
    formateDateSemBarra,
    formateRSS
};